<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Ver Asistencia Folio:{{ folio }}
            <div>
              <!-- <router-link
                :to="{
                  name: 'EditAsistencia',
                  params: {
                    folio: folio,
                  }
                }"
              >
                <CButton color="success" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-pencil" />Editar
                </CButton>
              </router-link> -->
              <!-- <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
              </CButton> -->
              <router-link :to="{ name: 'Asistencia' }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author?this.item.author.correo:'' }}
            </CCol>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  v-model="fechahora"
                  disabled
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Trabajador:</label>
                <CInput v-model="trabajador" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Evento:</label>
                <CInput v-model="evento" disabled horizontal />
              </CCol>
            </CRow>

           
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from "moment";

import "vue-select/dist/vue-select.css";

export default {
  name: "VerAsistencia",
  
  
  data() {
    return {
      folio: this.$route.params.id,

      fechahora: "",
      isLoading: false,
      isLoadingPage: false,
      trabajadores: [],
      trabajador: null,
      successModal: false,
      warningModal: false,
      nanoid: undefined,
      evento: "",
      error: "",

      item:{}
    };
  },
  created() {
    this.isLoadingPage = true;
    this.isLoading = true;


    const ubi = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "asistencias",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"] : ["*"]
      })
    ];



    // ubi.push(ubicacionTemplateNoRaiz);

    Promise.all(ubi)
      .then(([item]) => {

          
        this.item = item.data[0];
        this.trabajador = this.item.payload.encabezado._relaciones.trabajador.payload.nombre;
        this.evento = this.item.payload.encabezado.evento;
        this.fechahora = moment(this.item.payload.encabezado.fechahora, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
      })
      .finally(() => (this.isLoading = false));
  },
  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
</style>
